var map = {
	"./Galileo-Corporate-Fact-Sheet-English.pdf": [
		92060,
		92060
	],
	"./global/CTA3D.mp4": [
		43169,
		43169
	],
	"./global/CTA3D.webm": [
		36683,
		36683
	],
	"./global/ClientVid.mp4": [
		1872,
		1872
	],
	"./global/ClientVid.webm": [
		56832,
		56832
	],
	"./global/fonts/Plain-Bold.woff": [
		59288,
		59288
	],
	"./global/fonts/Plain-Regular.woff": [
		62509,
		62509
	],
	"./homepage/HomeHero3D.mp4": [
		8659,
		8659
	],
	"./homepage/HomeHero3D.webm": [
		55497,
		55497
	],
	"./homepage/HomeHero3DM.mp4": [
		14066,
		14066
	],
	"./homepage/HomeHero3DM.webm": [
		18846,
		18846
	],
	"./homepage/homeFooter.mp4": [
		59515,
		59515
	],
	"./homepage/homeFooter.webm": [
		90977,
		90977
	],
	"./homepage/homeFooterM.mp4": [
		1402,
		1402
	],
	"./homepage/homeFooterM.webm": [
		19862,
		19862
	],
	"./homepage/homeHero3Dnew.mp4": [
		51433,
		51433
	],
	"./pdf/en/Galileo-Corporate-Fact-Sheet.pdf": [
		33538,
		33538
	],
	"./pdf/es/Galileo-Corporate-Fact-Sheet.pdf": [
		19733,
		19733
	],
	"./pdf/pt/Galileo-Corporate-Fact-Sheet.pdf": [
		10285,
		10285
	],
	"./resources/2021-Galileo-Secured-Credit-Card-Report.pdf": [
		65592,
		65592
	],
	"./resources/2022-02-Tracker-Galileo.pdf": [
		45235,
		45235
	],
	"./resources/2022-04-Tracker-Galileo.pdf": [
		66641,
		66641
	],
	"./resources/2022_DIVES_Virtual_Card_Playbook__FINAL.pdf": [
		40950,
		40950
	],
	"./resources/2023_04_Tracker_-_Galileo_-_V8_SS.pdf": [
		98658,
		98658
	],
	"./resources/3_Steps_to_Digital_Transformation.pdf": [
		27445,
		27445
	],
	"./resources/AI-Powered-Conversational-Banking-Konecta-eBook-Galileo-Financial-Technologies.pdf": [
		63204,
		63204
	],
	"./resources/American_Banker_Customer_Experience_Survey-EN.pdf": [
		75222,
		75222
	],
	"./resources/B2B_Spend_Management_-_EN.pdf": [
		83710,
		83710
	],
	"./resources/Banco_Original_Case_Study_-_EN.pdf": [
		90455,
		90455
	],
	"./resources/Brochure_Cyberbank-Konecta.pdf": [
		83009,
		83009
	],
	"./resources/Buy-Now-Pay-Later_Galileo_Product_Flyer.pdf": [
		29199,
		29199
	],
	"./resources/Case_Study_Banco_Del_Pacifico.pdf": [
		74510,
		74510
	],
	"./resources/Cyberbank_Core_Brochure-EN.pdf": [
		33551,
		33551
	],
	"./resources/Cyberbank_Digital_Brochure-EN.pdf": [
		92252,
		92252
	],
	"./resources/Cyberbank_Digital_eBook.pdf": [
		55626,
		55626
	],
	"./resources/Digital_Disruption_eBook-Final.pdf": [
		10795,
		10795
	],
	"./resources/Falabella-Case-Study-EN.pdf": [
		88632,
		88632
	],
	"./resources/Falabella_Case_Study-min.pdf": [
		40451,
		40451
	],
	"./resources/Folha_de_dados_corporativos_da_Galileo_-_PT.pdf": [
		71170,
		71170
	],
	"./resources/Galileo-Anti-Fraud-Playbook-Final-Version.pdf": [
		38902,
		38902
	],
	"./resources/Galileo-B2B-Digital-Payments-Adoption-Playbook.pdf": [
		68951,
		68951
	],
	"./resources/Galileo-BaaS-eBook.pdf": [
		69733,
		69733
	],
	"./resources/Galileo-Corporate-Fact-Sheet-English.pdf": [
		6818,
		6818
	],
	"./resources/Galileo-Corporate-Fact-Sheet-English__1_.pdf": [
		28992,
		28992
	],
	"./resources/Galileo-Growth-Activation-ebook.pdf": [
		5158,
		5158
	],
	"./resources/Galileo-Growth-Activation-ebook_PT_version.pdf": [
		2904,
		2904
	],
	"./resources/Galileo-Growth-Activation-ebook_SP_version.pdf": [
		9325,
		9325
	],
	"./resources/Galileo-Juniper-Research-ebook-2022.pdf": [
		97154,
		97154
	],
	"./resources/Galileo-Juniper-Research-ebook-2022_FINAL.pdf": [
		66791,
		66791
	],
	"./resources/Galileo-research-executive-summary.pdf": [
		13838,
		13838
	],
	"./resources/Galileo_Corp_Brochure_DME_v2_April23.pdf": [
		47750,
		47750
	],
	"./resources/Galileo_Cyberbank_Konecta_and_SoFi_-_EN.pdf": [
		86620,
		86620
	],
	"./resources/Galileo_Infographic_Top-5-Ways-to-Win-with-SMBs.pdf": [
		44182,
		44182
	],
	"./resources/Hoja_de_datos_corporativos_de_Galileo_Financial_Technologies.pdf": [
		38352,
		38352
	],
	"./resources/How_BaaS_Can_Help_FIs_Win_More_Customers.pdf": [
		95986,
		95986
	],
	"./resources/Humanize_the_banking_experience_infographic_-_EN.pdf": [
		39535,
		39535
	],
	"./resources/Konecta-Brochure.pdf": [
		34745,
		34745
	],
	"./resources/Konecta_Folheto_-_PT.pdf": [
		73495,
		73495
	],
	"./resources/Konecta_Folleto.pdf": [
		88828,
		88828
	],
	"./resources/Microsoft-Galileo-Scaleability_Report-EN.pdf": [
		93437,
		93437
	],
	"./resources/PYMNTS-Embbed-Finance-Tracker-June-July-2022.pdf": [
		26625,
		26625
	],
	"./resources/PYMNTS-Embbeded-Finance-Tracker-6.pdf": [
		40236,
		40236
	],
	"./resources/PYMNTS-Embed-Finance-Tracker-September-2022.pdf": [
		81755,
		81755
	],
	"./resources/PYMNTS-Embedded-Finance-Tracker-October-2022.pdf": [
		61593,
		61593
	],
	"./resources/SoFi-Konecta-Case-Study-EN.pdf": [
		33319,
		33319
	],
	"./resources/Tailored_Banking_-_EN.pdf": [
		59116,
		59116
	],
	"./resources/Tendencias-de-consumo-FinTech-en-Ame__rica-Latina_Galieo-Financial-Technologies_2022 (1).pdf": [
		87785,
		87785
	],
	"./resources/Tendencias-de-consumo-FinTech-en-Ame__rica-Latina_Galieo-Financial-Technologies_2022.pdf": [
		68379,
		68379
	],
	"./resources/ebook-ai-powered-conversational-banking-draft.pdf": [
		72983,
		72983
	],
	"./resources/galileo_research_ebook.pdf": [
		5741,
		5741
	],
	"./resources/updated_ResearchEbookSplit_Fintech_Market_Opportunitites_082522.pdf": [
		29593,
		29593
	],
	"./resources/updated_ResearchEbookSplit_The_Digital_Shift_082522.pdf": [
		43690,
		43690
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 59620;
module.exports = webpackAsyncContext;